module.exports = __webpack_public_path__ + "img/image-error.fee9458c.png";